<template>
  <g>
    <path
      d="M12 17.25L7.52603 12.582C6.71903 11.777 6.51803 10.546 7.02603 9.526C7.68003 8.218 9.27103 7.688 10.579 8.343C10.833 8.47 11.065 8.637 11.266 8.838L12 9.569L12.731 8.838C13.765 7.804 15.442 7.805 16.476 8.839C16.677 9.04 16.844 9.272 16.971 9.526C17.479 10.546 17.277 11.777 16.471 12.582L12 17.25Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 0.75C18.213 0.75 23.25 5.787 23.25 12C23.25 18.213 18.213 23.25 12 23.25C5.787 23.25 0.75 18.213 0.75 12C0.75 5.787 5.787 0.75 12 0.75Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconSocial",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>